"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const PageContent = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.436 0c.964 0 1.477.1 2.012.385.5.268.9.666 1.167 1.167.262.49.367.962.383 1.78l.002.232V13a3 3 0 01-3 3H3.564c-.964 0-1.477-.1-2.012-.385a2.817 2.817 0 01-1.167-1.167c-.262-.49-.367-.962-.383-1.78L0 12.436V3.564C0 2.6.1 2.087.385 1.552c.268-.5.666-.9 1.167-1.167.49-.262.962-.367 1.78-.383L3.564 0h8.872zM14 8H14v5a1 1 0 01-1 1H8v-.001H3.394l-.278-.008-.059-.004-.055-.004-.186-.023-.094-.02a.972.972 0 01-.227-.089.818.818 0 01-.346-.346c-.078-.145-.12-.289-.138-.594L2 12.606 2 5h11.999v3zM3 1a1 1 0 100 2 1 1 0 000-2zm1.5 6a.5.5 0 000 1h7a.5.5 0 000-1h-7zM4 9.5a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
  fill: "#ACB3BE",
  className: "fill"
}));

var _default = PageContent;
exports.default = _default;